<template>
  <div class="tags-holder">
      <h3>{{ title }}</h3>
      <a-spin
        :spinning="tagsLoading"
      >
        <div class="tags-holder">
            <div class="tag-row"
                v-for="tag in tags"
                :key="tag.id"
            >
                <a-spin
                    :spinning="tagLoading(tag.id)"
                >
                    <a-row>
                        <a-col
                            :xs="formItemLayout.labelCol.xs"
                            :sm="formItemLayout.labelCol.sm"
                        >
                        </a-col>
                        <a-col
                            :xs="formItemLayout.wrapperCol.xs"
                            :sm="formItemLayout.wrapperCol.sm"
                        >
                            <a-row>
                                <a-col
                                    :span="16"
                                >   
                                    <a-button
                                        v-if="!tagEditing(tag.id)" 
                                        v-on:click="editTag(tag.id)"
                                        block
                                        class="tag-display"
                                    >
                                        {{tag.name}}
                                    </a-button>
                                    <a-input
                                        :ref="`tag_input_${tag.id}`"
                                        :style="{
                                            textAlign: 'center'
                                        }"
                                        v-if="tagEditing(tag.id)"
                                        :disabled="!tagEditing(tag.id)"
                                        v-model="tag.name"
                                    />
                                </a-col>
                                <a-col
                                    :span="8"
                                >
                                    <template
                                        v-if="!tagEditing(tag.id)"
                                    >
                                        <a-button
                                            type="primary"
                                            icon="edit"
                                            v-on:click="editTag(tag.id)"
                                        >
                                        </a-button>
                                        <a-popconfirm   
                                            title="Biztosan törli?"
                                            placement="top"
                                            okText="Igen"
                                            cancelText="nem"
                                            v-on:confirm="deleteTag(tag.id)"
                                        >
                                            <a-button
                                                icon="delete"
                                            >
                                            </a-button>
                                        </a-popconfirm>
                                        
                                    </template>
                                    <template
                                        v-if="tagEditing(tag.id)"
                                    >
                                        <a-button
                                            type="primary"
                                            icon="check"
                                            v-on:click="confirmEditing(tag.id)"
                                        >
                                        </a-button>
                                        <a-button
                                            icon="stop"
                                            v-on:click="cancelEditingTag(tag.id)"
                                        >
                                        </a-button>
                                    </template>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-spin>
                
            </div>
        </div>
      </a-spin>
      <div class="new-tag-form">
          <a-spin
            :spinning="createTagLoading"
          >
            <a-form
                :form="newTagForm"
                v-on:submit="submitNewTag"
                layout="horizontal"
            >
                <a-form-item
                    label="Új címke"
                    v-bind="formItemLayout"
                >
                    <a-row>
                        <a-col
                            :span="16"
                        >
                            <a-input
                                :style="{
                                    textAlign: 'center'
                                }"
                                v-decorator="[
                                    'name',
                                    {
                                        rules: [{
                                            required: true,
                                            message: 'Írja be a címke nevét'
                                        }]
                                    }
                                ]"
                                placeholder="Címke neve"
                            >
                            </a-input>
                        </a-col>
                        <a-col
                            :span="8"
                        >
                            <a-button
                                html-type="submit"
                                type="primary"
                                icon="check"
                            >

                            </a-button>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-spin>
      </div>
  </div>
</template>

<script>
import { getTags, createTag, updateTag, deleteTag } from '@/http/api'
export default {

    props: {
        title: {
            type: String,
            default: 'TAG TITLE'
        },
        type: {
            type: String,
            default: 'empty'
        }
    },

    data() {
        return {
            tags: [],
            formItemLayout: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 4 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
            },
            tagsLoading: false,
            createTagLoading: false,
            cachedTag: null,
            cachedTags: []
        }
    },
    beforeCreate() {
        this.newTagForm = this.$form.createForm(this);
    },

    created() {
        this.requestTags();
    },

    methods: {
        requestTags() {
            this.tagsLoading = true;
            getTags({
                params: {
                    type: this.type
                }
            }).then(res => {
                this.tags = res.data.data.map(tag => {
                    tag.editing = false;
                    tag.loading = false;
                    return tag;
                });
                this.tagsLoading = false;
            })
        },
        submitNewTag($event) {
            $event.preventDefault();
            this.createTagLoading = true;
            this.newTagForm.validateFields((err, vals) => {
                if (!err) {
                    vals.type = this.type;
                    createTag(vals).then(res => {
                        console.log('TAG CREATED');
                        this.requestTags();
                        this.createTagLoading = false;
                        this.newTagForm.resetFields();
                    })
                    
                } else {
                    this.createTagLoading = false;
                }
            })
        },
        removeTag(uuid) {
            return new Promise((resolve, reject) => {
                deleteTag({}, uuid).then(res => {
                    console.log('DELETED', res);
                    resolve(res.data);
                }) 
            })
        },
        modifyTag(vals, uuid) {
            
            return new Promise((resolve, reject) => {
                const newTag = updateTag(vals, uuid).then(res => {
                    console.log('UPDATED', res);
                    resolve(res.data);
                })
            })
            
        },        
        findTagById(id) {
            return this.tags.find(el => el.id === id);
        },
        findTagIndexById(id) {
            return this.tags.findIndex(el => el.id === id);
        },
        tagLoading(id) {
            return this.findTagById(id).loading;
        },
        tagEditing(id) {
            return this.findTagById(id).editing;
        },
        deleteTag(id) {
            const tagIndex = this.findTagIndexById(id);
            this.tags[tagIndex].loading = true;
            this.removeTag(this.tags[tagIndex].uuid).then(res => {
                console.log('REMOVEDDTAG', res);
                const newTags = [...this.tags];
                newTags.splice(tagIndex, 1);
                this.tags = newTags;
            }) 
        },
        editTag(id) {
            const tagIndex = this.findTagIndexById(id);
            const tagToEdit = this.tags[tagIndex];
            const cachedTag = {...tagToEdit};
            const cachedTagIx = this.cachedTags.findIndex(el => el.id === cachedTag.id);
            let newCachedTags = [...this.cachedTags];
            if (cachedTagIx === -1) {
                newCachedTags.push(cachedTag)
            } else {
                newCachedTags[cachedTagIx] = cachedTag;
            }
            this.cachedTags = newCachedTags

            tagToEdit.editing = true;
            const newTags = [...this.tags];
            newTags[tagIndex] = tagToEdit;
            this.tags = newTags;
            this.$nextTick(() => {
                this.$refs[`tag_input_${tagToEdit.id}`][0].$el.select()
            });
        },
        cancelEditingTag(id) {
            const tagIndex = this.findTagIndexById(id);
            const newTags = [...this.tags];
            newTags[tagIndex] = this.cachedTags.find(el => el.id === id);
            this.tags = newTags;
            let newCachedTags = [...this.cachedTags];
            newCachedTags.splice(this.cachedTags.findIndex(el => el.id === id), 1);
            this.cachedTags = newCachedTags;
        },
        confirmEditing(id) {
            const tagIndex = this.findTagIndexById(id);
            this.tags[tagIndex].loading = true;

            const updatedVals = {
                name: this.tags[tagIndex].name,
                type: this.type
            };
            this.modifyTag(updatedVals, this.tags[tagIndex].uuid)
            .then(newTag => {
                console.log('NEWTAG', newTag);
                newTag.editing = false;
                newTag.loading = false;
                const newTags = [...this.tags]
                newTags[tagIndex] = newTag;
                this.tags = newTags;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    h3 {
        margin-left: 15%
    }
    .tag-row {
        margin-bottom: 10px;
    }
</style>